import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class PegPlanHeaderReferenceService extends BaseReferenceService {
  constructor() {
    super('PegPlanHeaderReference');
  }
}
